import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './components/Home/Home';
import Nosotros from './components/Nosotros/Nosotros';
import Industriales from './components/Services/Industriales/Industriales';
import Residenciales from './components/Services/Residenciales/Residenciales';
import Comerciales from './components/Services/Comerciales/Comerciales';
import Proyectos from './components/Proyectos/Proyectos';
import NotFound from './components/NotFound/NotFound';
import Contacto from './components/Contacto/Contacto';
import ScrollToTop from './components/ScrollToTop/ScrollToTop.jsx';

const Router = () => {
    return (
        <BrowserRouter>
            <Header />
            <ScrollToTop />
            <Routes>
                <Route exact path="/" element={<Home />} />
                <Route exact path='/nosotros' element={<Nosotros />} />
                <Route exact path='/servicios/industriales' element={<Industriales />} />
                <Route exact path='/servicios/residenciales' element={<Residenciales />} />
                <Route exact path='/servicios/comerciales' element={<Comerciales />} />
                <Route exact path='/proyectos' element={<Proyectos />} />
                <Route exact path="/contacto" element={<Contacto />} />
                <Route exact path='*' element={<NotFound />} />
            </Routes>
            <Footer />
        </BrowserRouter>
    )
}

export default Router